module.exports = __webpack_public_path__ + "static/media/Redeem.f171f75b.png";